// extracted by mini-css-extract-plugin
module.exports = {"Container":"UnknownRoute_Container__18OAa","Piggy":"UnknownRoute_Piggy__2fxzh"};